import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, InternalUserModel } from 'src/app/Services/AuthService/auth-service.service';
import { EmailService } from 'src/app/Services/Emails/email.service';
import { Notification_Service } from 'src/app/Services/Notifications/notification.service';



declare var $: any;
declare var kendo: any;

@Component({
  selector: 'app-update-contact',
  templateUrl: './update-contact.component.html',
  styleUrls: ['./update-contact.component.scss']
})
export class UpdateContactComponent implements OnInit {
  public checked = true;
  title = 'Registration-Portal';
  responseOutput = 'Please enter your credentials.';
  public successMessage: string = "";
  currentTab="";

  public listItems: Array<string> = [
    '  ', 'AL','AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS',
    'KY', 'LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH',
    'OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'
  ];

  user: InternalUserModel={
    _agentId:"",
    _agentGuid:"",
    _username:"",
    _email:"",
    _emailTwo:"",
    _phone:"",
    _phone2:"",
    _agentName :"",
    _password :"",
    _confPassword :"",
    _AgentAddress1 :"",
    _AgentAddress2 :"",
    _AgentAddress3 :"",
    _AgentAddress4 :"",
    _AgentAddress5 :"",
    _fax:"",
    _business:"",
    _contact:"",
  }

  showLoginButton=false;
  validateUserIcon=false;
  wasEmailChanged=false;
  wasSecondEmailChanged=false;
  enableLoginButn=false;
  emailOk=false;
  contactUpdated=false;

  showSpinner=false;
  cardWidth=100;
  showUpdateBtn=true;
  guid="";

  isUserNameAvailabe: boolean=false;
  public usernameAllowance = {
        title: 'Username Allows only',
        item1:'Alphanumeric characters [a – z] or uppercase [A – Z]',
        item2:'Digits [0 – 9] and underscores (_). Min 8 chars long.',
  };
  public passwordRequirements = {
    title: 'Password Requirements',
    item1:'At least 8 characters. A mixture of both uppercase and lowercase letters.',
    item2:'A mixture of letters and numbers. Include at least one special character.'
};
  
  agentForm: FormGroup;
  constructor(private formBuilder: FormBuilder, private _emailService:EmailService, private _authService:AuthService, private router: Router, private notificationService: Notification_Service, private activatedRoute: ActivatedRoute) {
    // String.prototype.matchAll()
   }

  ngOnInit() {
    this._authService.doLogoutUser(false)
    $(document).ready(function () {
      $("#authentication-wrapper").hover(function () {
        kendo.fx($("#authentication-wrapper")).zoom("in").startValue(1).endValue(1.05).play();
      }, () => {
        kendo.fx($("#authentication-wrapper")).zoom("out").endValue(1).startValue(1.05).play();
      });
    })

    this.activatedRoute.params.subscribe(params => {
       this.guid = params['id']; //Value passed in the URL should be a GUID
      this._authService.authenticate(this.guid)
    });
     
    this.agentForm = this.formBuilder.group({
      contact: [ '', Validators.required ],
      business: ['', Validators.required] ,
      phone:  [ '',Validators.required],
      phone2:  [ '',Validators.required],
      fax:  [ '',Validators.required],
      email:  [ '',Validators.required],
      email2:  [ '',Validators.required],
      agentAddress2:  [ ''],
      agentAddress3:  [ ''],
      agentAddress4:  [ ''],
      agentAddress5:  [ ''],
    })

    this._authService.selectedUser.subscribe(x=>{
      if(x){  this.user =x ;
        this.agentForm.controls.contact.setValue(x._contact)
        this.agentForm.controls.business.setValue(x._business)
        this.agentForm.controls.phone.setValue(x._phone)
        this.agentForm.controls.phone2.setValue(x._phone2)
        this.agentForm.controls.fax.setValue(x._fax)
        this.agentForm.controls.email.setValue(x._email)
        this.agentForm.controls.email2.setValue(x._emailTwo)
        this.agentForm.controls.agentAddress2.setValue(x._AgentAddress2)
        this.agentForm.controls.agentAddress3.setValue(x._AgentAddress3)
        this.agentForm.controls.agentAddress4.setValue(x._AgentAddress4)
        this.agentForm.controls.agentAddress5.setValue(x._AgentAddress5)

        for (var i in this.agentForm.controls) {
          this.agentForm.controls[i].markAsTouched();
        }
       }
    });
  }

  get f(){//In use from the HTML
    return this.agentForm.controls
  }

  emailChanged(value:any){
    if(value){
        if( this._authService.getEmails().email1 === value){
          this.wasEmailChanged= false;
        }
        else{
          this.wasEmailChanged= true;
        }
    }else
    this.wasEmailChanged= false;
  }

  secondEmailChanged(value:any){
        if(value){
          if(this._authService.getEmails().email2 === value){
            this.wasSecondEmailChanged=false;
          }
          else{
            this.wasSecondEmailChanged = true;
          }
    }else
    this.wasSecondEmailChanged= false;
  }

  updateContact(){
    updateUser(this.user, this.agentForm.controls)
    this.showSpinner =true;
    this.contactUpdated=true;
    this._authService.UpdateContact(this.user).subscribe( (x:any) =>{
        this.showSpinner =false;
        if(this.wasEmailChanged || this.wasSecondEmailChanged) {
          if(this.wasEmailChanged) this._emailService.sendEmailConfirmationEmail(this.user._email, x.resetEmail1Guid)
          if(this.wasSecondEmailChanged)  this._emailService.sendEmailConfirmationEmail(this.user._emailTwo, x.resetEmail2Guid)
          
          this.successMessage="Your profile was successfuly Updated. ";
          this.successMessage += (this.wasEmailChanged)? ("<br> A Confirmation Email was sent to <strong>"+this.user._email+"</strong> for verification."): "";
          this.successMessage += (this.wasEmailChanged && this.wasSecondEmailChanged)? "<br>  In Addition ": "";
          this.successMessage += (this.wasSecondEmailChanged)? ("<br> A Confirmation Email was sent to <strong>"+this.user._emailTwo+"</strong> for verification.") :"";
           this.successMessage += (this.wasSecondEmailChanged || this.wasEmailChanged)? ("<br> Changes to VAB Emails and PA Exchange Email require confirmaton to take effect.") :"";
        }else{
          this._authService.isAccountActive(this.guid).subscribe((response:any) => {
            if(!response.isAccountActive) {
              this.successMessage="Your profile was successfuly Updated. <br> Proceed to activate your account.";    
            }
            else{
              this.showLoginButton=true;
              this.successMessage =" Your Account has already been activated. Please Navigate to the  Log-In page."
            }
          });
        }
    },
    error =>{
      debugger
      let a= error;
    } );

  }

  okClicked(){
    this._authService.isAccountActive(this.guid).subscribe((response:any) => {
      if(!response.isAccountActive) {
        this.router.navigateByUrl('/activate-account/'+ this.guid);  
      }
      else{
        this.showLoginButton=true;
        this.successMessage =" Your Account has already been activated. Please Navigate to the  Log-In page."
      }
    });
  }

  navigatetoLogin(){
    // this.successMessage='';
    this.router.navigateByUrl('/sign-in');
  }
}
function updateUser(user:any, controls:any) {
  user._contact= controls.contact.value
  user._business= controls.business.value
  user._AgentAddress2= controls.agentAddress2.value
  user._AgentAddress3= controls.agentAddress3.value
  user._AgentAddress4= controls.agentAddress4.value
  user._AgentAddress5= controls.agentAddress5.value
  user._email= controls.email.value
  user._emailTwo= controls.email2.value
  user._fax= controls.fax.value
  user._phone= controls.phone.value
  user._phone2= controls.phone2.value
}

